import * as React from "react";
import downloadjs from "downloadjs";
import { Base } from "ui/Scripts/source/framework/base";
import { SaveDataObj } from "../../framework/saveData";
import { customHistory } from "../../framework/customHistory";
import { RouteComponentProps } from "react-router";
import * as store from "../../framework/customStore";
import * as storeTypes from "../../models/store/storeTypes";
import * as taskService from "../../models/services/taskService";
import * as storeActions from "../../models/store/storeActions";
import * as attachmentService from "../../models/services/attachmentService";
import { Session } from "../../models/session/session";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITaskEditItem, TaskEditItem } from "../../models/task/taskEditItem";
import { ITaskDataRowCol, SaveTaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskDataRow, SaveTaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskHandler, SaveTaskHandler, TaskHandler } from "../../models/task/taskHandler";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskStateItem, TaskStateItem } from "../../models/task/taskStateItem";
import { ITaskEditPriorityItem } from "../../models/task/taskEditPriorityItem";
import { IUnitItem, UnitItem } from "../../models/unit/unitItem";
import { EditPageHeader } from "../app/header";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { AttachmentList } from "../attachment/attachmentList";
import { CameraPhoto } from "../framework/cameraPhoto";
import { SelectIdCodeDialog } from "../framework/selectIdCodeDialog";
import { IdCode, IIdCode } from "../../models/common/idCode";
import { IEndlessList, EndlessList } from "ui/Scripts/source/models/common/endlessList";
import { SelectUnitDialog } from "../event/selectUnitDialog";
import { RadioButton } from "ui/Scripts/source/components/framework/radio";
import { TaskHandlerList } from "./taskHandlerList";
import { TaskDynamicForm } from "./taskDynamicForm";
import { ConfirmationDialogResult, DatabaseRecordType, EnumHelper, TaskLockingType, TaskRepetitionType } from "ui/Scripts/source/models/enums";
import { TaskDataRowList } from "./taskDataRowList";
import { SelectTaskStateDialog } from "./selectTaskStateDialog";
import { IUnlockResult } from "../../models/common/unlockResult";
import { TaskTypeCol, ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IUserListItem } from "../../models/user/userListItem";
import { SaveAttachmentBase64 } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { AppUtils } from "../../framework/appUtils";
import { Footer } from "../app/footer";
import { LockedToOtherUser } from "../locking/lockedToOtherUser";
import { CalendarTaskListOfRecord } from "../calendarTask/calendarTaskListOfRecord";
import { IUserState } from "../../models/store/storeTypes";
import { IIdCodeDivider } from "source/models/common/idCodeDivider";

export interface ITaskEditOwnProps {
}

export interface ITaskEditStateProps {
    user: IUserState;
    item: ITaskEditItem;
    taskTypes: ITaskEditTypeItem[];
    taskStates: ITaskStateItem[];
    taskPriorities: ITaskEditPriorityItem[];
    units: IUnitItem[];
    userCode: string;
    userName: string;
    userPicture: string;
    canHandleTask: boolean;
    canRemoveTask: boolean;
    canChangeTaskState: boolean;
    userIsIsSystemAdmin: boolean;
    returnUrl: string;
}

export interface ITaskEditDispatchProps {
    loadTask: (id: string) => void;
    resetTask: () => void;
}

export interface ITaskEditPathProps {
    taskId: string;
}

type TaskEditViewProp = ITaskEditOwnProps & ITaskEditStateProps & ITaskEditDispatchProps & RouteComponentProps<ITaskEditPathProps>;

/* eslint-disable no-unused-vars */
const enum NewTaskWizardWindowType {
    Category = "0",
    Unit = "1",
    TaskType = "2",
    TaskState = "3",
    TaskPriority = "4"
}

const enum CategoryType {
    Public = "0",
    Private = "1"
}
/* eslint-enable no-unused-vars */

interface ITaskEditViewState {
    isNew: boolean;
    id: string;
    rowId: string;
    taskTypeId: string;
    taskStateId: string;
    taskPriorityId: string;
    unitId: string;
    unitCode: string;
    code: string;
    name: string;
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;
    taskHeaderDataCols: ITaskDataRowCol[];
    taskDataRows: ITaskDataRow[];
    repeatedTaskDataRows: ITaskDataRow[];
    taskHandlers: ITaskHandler[];
    savedTaskDataRowIds: string[];
    removedTaskDataRowIds: string[];
    savedTaskHandlerIds: string[];
    removedTaskHandlerIds: string[];
    photoAttachmentIds: string[];
    removedAttachmentIds: string[];
    //Camera
    cameraIds: string[];
    showCamera: boolean;
    showingCamera: boolean;
    cameraTaskDataRowId: string;
    cameraSetRowDataNewCameraFileAttachment: boolean;
    //Calculated fields
    taskType: ITaskEditTypeItem;
    taskState: ITaskStateItem;
    taskPriorityCode: string;
    //Sections
    taskHandlersVisible: boolean;
    calendarTasksVisible: boolean;
    headerFormEditMode: boolean;
    nameOld: string;
    taskHeaderDataColsOld: ITaskDataRowCol[];
    rowDataNewCameraFileAttachment: FileAttachment;
    //Dialogs
    categories: IIdCode[];
    newTaskWizardWindows: NewTaskWizardWindowType[];
    newTaskWizardWindowIndex: number;
    showSelectTaskTypeDialog: boolean;
    showSelectTaskStateDialog: boolean;
    showSelectTaskPriorityDialog: boolean;
    showSelectUnitDialog: boolean;
}
    
interface INewTaskWizardWindows {
    windows: NewTaskWizardWindowType[];
    index: number;
}

export class TaskEditView extends React.Component<TaskEditViewProp, ITaskEditViewState> {
    private static orgStateHash = "";
    private static hashIgnoreSaveDataFields = ["id", "rowId"];

    private dataContainerDiv: HTMLDivElement;
    private companyLogo: string;
    private scrollToTop: boolean;
    private scrollToClassName: string;

    private static isRepeatedTask = (taskType: ITaskEditTypeItem): boolean => {
        return taskType && EnumHelper.isEqual(taskType.taskRepetitionType, TaskRepetitionType.Repeated);
    };

    private static getSaveDataFromState = async (props: TaskEditViewProp, state: ITaskEditViewState): Promise<SaveDataObj> => {
        const task = props.item;
        const data = new SaveDataObj();
        data.append("id", task.id);
        data.append("rowId", state.rowId);
        data.append("companyId", task.companyId);
        data.append("unitId", !state.unitId ? null : state.unitId);
        data.append("taskTypeId", state.taskTypeId);
        data.append("taskStateId", state.taskStateId);
        data.append("taskPriorityId", state.taskPriorityId);
        data.append("name", state.name);
        //TaskHandlers
        data.append("saveTaskHandlers", state.taskHandlers.reduce((result, i) => {
            if (state.savedTaskHandlerIds.indexOf(i.id) >= 0) {
                result.push(new SaveTaskHandler(i));
            }
            return result;
        }, []));
        data.append("removeTaskHandlerIds", state.removedTaskHandlerIds);
        //TaskHeaderDataCols
        const saveHeaderDataCols = TaskDataRowCol.getToBeSavedTaskDataRowCols(state.taskType.headerCols, state.taskHeaderDataCols);
        data.append("saveTaskHeaderDataCols", saveHeaderDataCols.reduce((result, i) => {
            result.push(new SaveTaskDataRowCol(i));
            return result;
        }, []));
        if (!TaskEditView.isRepeatedTask(state.taskType)) {
            //TaskDataRows
            data.append("saveTaskDataRows", state.taskDataRows.reduce((result, i) => {
                if (state.savedTaskDataRowIds.indexOf(i.id) >= 0) {
                    result.push(SaveTaskDataRow.createSaveTaskDataRow(state.taskType.formCols, i, null));
                }
                return result;
            }, []));
            data.append("removeTaskDataRowIds", state.removedTaskDataRowIds);
            //TaskDataRow Attachments
            const attachments: SaveAttachmentBase64[] = [];
            const attachmentsTaskDataRowIds: string[] = [];
            //const photoAttachmentsTaskDataRowIds: string[] = [];
            for (let i = 0; i < state.taskDataRows.length; i++) {
                const taskDataRow = state.taskDataRows[i];
                if (state.savedTaskDataRowIds.indexOf(taskDataRow.id) < 0) continue;
                for (const fileAttachment of taskDataRow.attachments.filter(i => !!i.file)) {
                    const attachment = await SaveAttachmentBase64.fromFileAttachment(state.photoAttachmentIds.indexOf(fileAttachment.id) > -1 ? "photo" : "", fileAttachment);
                    if (!attachment) continue;
                    attachments.push(attachment);
                    attachmentsTaskDataRowIds.push(taskDataRow.id);
                }
            }
            data.append("attachments", attachments);
            data.append("attachmentsTaskDataRowIds", attachmentsTaskDataRowIds);
        }
        //Attachments
        data.append("removeAttachmentIds", state.removedAttachmentIds);
        return data;
    };

    private static getNewTaskWizardWindows(props: TaskEditViewProp): INewTaskWizardWindows {
        const result: INewTaskWizardWindows = {
            windows: [],
            index: -1
        };
        const isNew = props.match.params.taskId === Base.emptyGuid;
        if (!isNew) return result;
        const publicTaskTypes = props.taskTypes.filter(i => i.isVisible(false));
        if (props.units.length > 0 && publicTaskTypes.length > 0) {
            result.windows.push(NewTaskWizardWindowType.Category);
        }
        if (props.units.length > 1 && publicTaskTypes.length > 0) {
            result.windows.push(NewTaskWizardWindowType.Unit);
        }
        if (props.taskTypes.length > 1) {
            result.windows.push(NewTaskWizardWindowType.TaskType);
        }
        if (props.taskStates.length > 1) {
            result.windows.push(NewTaskWizardWindowType.TaskState);
        }
        if (props.taskPriorities.length > 1) {
            result.windows.push(NewTaskWizardWindowType.TaskPriority);
        }
        if (result.windows.length > 0) {
            result.index = 0;
        }
        return result;
    }

    private static getStateFromProps = (props: TaskEditViewProp, cameraIds: string[]): ITaskEditViewState => {
        const isNew = props.match.params.taskId === Base.emptyGuid;
        let item = props.item;
        if (Base.isNullOrUndefined(item)) {
            item = new TaskEditItem();
        }
        let taskType = props.taskTypes.find(i => i.id === item.taskTypeId);
        if (Base.isNullOrUndefined(taskType)) {
            taskType = new TaskEditTypeItem();
        }
        const taskState = props.taskStates.find(i => i.id === item.taskStateId);
        const taskPriority = props.taskPriorities.find(i => i.id === item.taskPriorityId);
        const unit = props.units.find(i => i.id === item.unitId);
        const isRepeatedTask = TaskEditView.isRepeatedTask(taskType);
        const firstTaskDataRow = item.taskDataRows.length > 0 ? item.taskDataRows[0] : null;
        const newTaskWizardWindows = TaskEditView.getNewTaskWizardWindows(props);
        const categories: IIdCode[] = [];
        if (props.units.length > 0) {
            categories.push(IdCode.createIdCode(CategoryType.Public, Translations.Public));
        }
        categories.push(IdCode.createIdCode(CategoryType.Private, Translations.Private));
        const result: ITaskEditViewState = {
            isNew,
            id: item.id,
            rowId: item.rowId,
            taskTypeId: item.taskTypeId,
            taskStateId: item.taskStateId,
            taskPriorityId: item.taskPriorityId,
            unitId: item.unitId,
            code: item.code,
            name: item.name,
            lockedDate: item.lockedDate,
            lockedUserCode: item.lockedUserCode,
            lockedUserName: item.lockedUserName,
            lockedUserPicture: item.lockedUserPicture,
            taskHeaderDataCols: item.taskHeaderDataCols.slice(0),
            taskDataRows: item.taskDataRows.slice(0),
            repeatedTaskDataRows: [],
            taskHandlers: item.taskHandlers.slice(0),
            savedTaskDataRowIds: !isRepeatedTask && !!firstTaskDataRow ? [firstTaskDataRow.id] : [],
            removedTaskDataRowIds: [],
            savedTaskHandlerIds: [],
            removedTaskHandlerIds: [],
            photoAttachmentIds: [],
            removedAttachmentIds: [],
            //Camera
            cameraIds,
            showCamera: false,
            showingCamera: false,
            cameraTaskDataRowId: "",
            cameraSetRowDataNewCameraFileAttachment: false,
            //Calculated fields
            taskType: !Base.isNullOrUndefined(taskType) ? taskType : new TaskEditTypeItem(),
            taskState: !Base.isNullOrUndefined(taskState) ? taskState : new TaskStateItem(),
            taskPriorityCode: !Base.isNullOrUndefined(taskPriority) ? taskPriority.code : "",
            unitCode: !Base.isNullOrUndefined(unit) ? unit.name : "",
            //Sections
            taskHandlersVisible: false,
            calendarTasksVisible: false,
            headerFormEditMode: isNew,
            nameOld: item.name,
            taskHeaderDataColsOld: item.taskHeaderDataCols.map(i => new TaskDataRowCol(i)),
            rowDataNewCameraFileAttachment: null,
            //Dialogs
            categories,
            newTaskWizardWindows: newTaskWizardWindows.windows.slice(0),
            newTaskWizardWindowIndex: newTaskWizardWindows.index,
            showSelectTaskTypeDialog: false,
            showSelectTaskStateDialog: false,
            showSelectTaskPriorityDialog: false,
            showSelectUnitDialog: false,
        };
        if (!Base.isNullOrEmpty(item.id)) {
            TaskEditView.getSaveDataFromState(props, result)
                .then(saveData => {
                    TaskEditView.orgStateHash = saveData.getHash(TaskEditView.hashIgnoreSaveDataFields);
                });
        } else {
            TaskEditView.orgStateHash = "";
        }
        return result;
    };

    constructor(props: TaskEditViewProp) {
        super(props);
        this.companyLogo = null;
        this.scrollToTop = false;
        this.scrollToClassName = null;
        this.state = TaskEditView.getStateFromProps(props, []);
    }

    static getDerivedStateFromProps(nextProps: TaskEditViewProp, prevState: ITaskEditViewState): ITaskEditViewState {
        if (Base.isNullOrUndefined(prevState.id) || (!Base.isNullOrUndefined(nextProps.item) && nextProps.item.id !== prevState.id)) {
            return TaskEditView.getStateFromProps(nextProps, prevState.cameraIds.slice(0));
        } else {
            return null;
        }
    }

    private scrollToRowElement = () => {
        //console.log("scrollToRowElement", this.scrollToClassName);
        if (!Base.isNullOrEmpty(this.scrollToClassName)) {
            if (this.dataContainerDiv.scrollTo !== null && this.dataContainerDiv.scrollTo !== undefined) {
                const elements = this.dataContainerDiv.getElementsByClassName(this.scrollToClassName);
                if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
                    const y = (elements[0] as HTMLDivElement).offsetTop;
                    this.dataContainerDiv.scrollTo({
                        top: y,
                        left: 0,
                        behavior: "auto"
                    });
                }
            }
            this.scrollToClassName = null;
        }
    };

    componentDidMount(): void {
        const obj = this;
        Base.getCameraIds()
            .then(ids => {
                obj.setState({ cameraIds: ids });
            })
            .catch(() => {
                obj.setState({ cameraIds: [] });
            });
        this.props.loadTask(this.props.match.params.taskId);
        //Set companyLogo
        Session.getCompanyLogo().then((companyLogo) => {
            obj.companyLogo = companyLogo;
        });
    }

    componentDidUpdate(prevProps: TaskEditViewProp, prevState: ITaskEditViewState, snapshot: any): void {
        if (this.scrollToTop) {
            if (!this.dataContainerDiv.scrollTo) {
                this.dataContainerDiv.scrollTop = 0;
                this.dataContainerDiv.scrollLeft = 0;
            } else {
                this.dataContainerDiv.scrollTo(0, 0);
            }
            this.scrollToTop = false;
        } else {
            //Scroll to attachments after closing camera
            this.scrollToRowElement();
        }
    }

    componentWillUnmount(): void {
        this.props.resetTask();
    }

    //#region Camera
    hasCameras = (): boolean => {
        return !Base.isNullOrUndefined(this.state.cameraIds) && this.state.cameraIds.length > 0;
    };
    
    handleCameraStreamAvailable = () => {
        this.setState({ showingCamera: true });
    };

    handleAttachmentAddPhoto = (rowId: string, setRowDataNewCameraFileAttachment: boolean) => {
        if (!this.hasCameras()) return;
        this.setState({ showCamera: true, cameraTaskDataRowId: rowId, cameraSetRowDataNewCameraFileAttachment: setRowDataNewCameraFileAttachment });
    };

    handleCameraPhotoOk = (dataUrl: string) => {
        const state = this.state;
        //this.setScrollToClassNameByEventAttachmentCategory();
        if (Base.isNullOrEmpty(dataUrl) || Base.isNullOrEmpty(state.cameraTaskDataRowId) && !state.cameraSetRowDataNewCameraFileAttachment) {
            this.setState({ showCamera: false, showingCamera: false });
            return;
        }
        FileAttachment.photoToFileAttachment(dataUrl, 0).then(attachment => {
            if (Base.isNullOrUndefined(attachment)) return;
            if (!state.cameraSetRowDataNewCameraFileAttachment) {
                const taskDataRows = state.taskDataRows.slice(0);
                const taskDataRow = taskDataRows.find(i => i.id === state.cameraTaskDataRowId);
                if (Base.isNullOrUndefined(taskDataRow)) return;
                taskDataRow.attachments.push(attachment);
                const photoAttachmentIds = state.photoAttachmentIds.slice(0);
                photoAttachmentIds.push(attachment.id);
                this.setState({ taskDataRows, photoAttachmentIds, showCamera: false, showingCamera: false });
            } else {
                this.setState({ rowDataNewCameraFileAttachment: attachment, showCamera: false, showingCamera: false });
            }
        });
    };

    handleCameraPhotoCancel = (permissionDenied: boolean) => {
        //this.setScrollToClassNameByEventAttachmentCategory();
        if (!permissionDenied) {
            this.setState({ showCamera: false, showingCamera: false });
        } else {
            this.setState({ showCamera: false, showingCamera: false, cameraIds: [] });
        }
    };
    //#endregion Camera

    //#region New Task Wizard
    handleLoadCategories = (page: number): Promise<IEndlessList<IIdCode>> => {
        const obj = this;
        return new Promise<IEndlessList<IIdCode>>((resolve, reject) => {
            const result = new EndlessList<IIdCode>(null, IdCode);
            result.items = obj.state.categories;
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    setUnit = (id: string, newTaskWizardWindowIndex: number, showSelectUnitDialog: boolean) => {
        if (Base.isNullOrEmpty(id)) return;
        const unit = this.props.units.find(i => i.id === id);
        if (Base.isNullOrUndefined(unit)) return;
        this.setState({
            newTaskWizardWindowIndex,
            showSelectUnitDialog,
            unitId: id,
            unitCode: unit.name,
        });
    };

    setTaskType = (id: string, newTaskWizardWindowIndex: number, showSelectTaskTypeDialog: boolean) => {
        const isNew = this.props.match.params.taskId === Base.emptyGuid;
        if (!isNew || !id) return;
        const taskType = this.props.taskTypes.find(i => i.id === id);
        if (!taskType) return;
        const taskHeaderDataCols = TaskDataRowCol.initializeValuesByType(taskType.headerCols, []);
        const taskDataRows: ITaskDataRow[] = [];
        const savedTaskDataRowIds: string[] = [];
        if (!TaskEditView.isRepeatedTask(taskType)) {
            const taskDataRow = new TaskDataRow();
            taskDataRow.id = Base.getGuid();
            taskDataRow.initializeToTaskType(taskType);
            taskDataRows.push(taskDataRow);
            savedTaskDataRowIds.push(taskDataRow.id);
        }
        this.setState({
            newTaskWizardWindowIndex,
            showSelectTaskTypeDialog,
            taskTypeId: id,
            taskType,
            //Initialize task type related data
            taskHeaderDataCols,
            taskDataRows,
            repeatedTaskDataRows: [],
            savedTaskDataRowIds,
            removedTaskDataRowIds: [],
            taskHeaderDataColsOld: taskHeaderDataCols.map(i => new TaskDataRowCol(i)),
        });
    };

    setTaskState = (id: string, newTaskWizardWindowIndex: number, showSelectTaskStateDialog: boolean) => {
        if (Base.isNullOrEmpty(id)) return;
        const taskState = this.props.taskStates.find(i => i.id === id);
        if (Base.isNullOrUndefined(taskState)) return;
        this.setState({
            newTaskWizardWindowIndex,
            showSelectTaskStateDialog,
            taskStateId: id,
            taskState
        });
    };

    setTaskPriority = (id: string, newTaskWizardWindowIndex: number, showSelectTaskPriorityDialog: boolean) => {
        if (Base.isNullOrEmpty(id)) return;
        const taskPriority = this.props.taskPriorities.find(i => i.id === id);
        if (Base.isNullOrUndefined(taskPriority)) return;
        this.setState({
            newTaskWizardWindowIndex,
            showSelectTaskPriorityDialog,
            taskPriorityId: id,
            taskPriorityCode: taskPriority.code
        });
    };

    handleNewTaskWizardCategoryDialogNext = (id: string) => {
        const state = this.state;
        if (Base.isNullOrEmpty(id)) return;
        const isPrivate = id === CategoryType.Private;
        const increment = !isPrivate ? 1 : 2;
        const newTaskWizardWindowIndex = state.newTaskWizardWindowIndex + increment < state.newTaskWizardWindows.length ? state.newTaskWizardWindowIndex + increment : -1;
        this.setState({
            newTaskWizardWindowIndex,
            unitId: isPrivate ? null : (state.unitId || this.props.units[0].id),
            unitCode: isPrivate ? "" : (state.unitCode || this.props.units[0].name)
        });
    };

    handleNewTaskWizardUnitDialogNext = (id: string) => {
        const state = this.state;
        this.setUnit(id, state.newTaskWizardWindowIndex + 1 < state.newTaskWizardWindows.length ? state.newTaskWizardWindowIndex + 1 : -1, state.showSelectUnitDialog);
    };

    handleNewTaskWizardTaskTypeDialogNext = (id: string) => {
        const state = this.state;
        this.setTaskType(id, state.newTaskWizardWindowIndex + 1 < state.newTaskWizardWindows.length ? state.newTaskWizardWindowIndex + 1 : -1, state.showSelectTaskTypeDialog);
    };

    handleNewTaskWizardTaskStateDialogNext = (id: string) => {
        const state = this.state;
        this.setTaskState(id, state.newTaskWizardWindowIndex + 1 < state.newTaskWizardWindows.length ? state.newTaskWizardWindowIndex + 1 : -1, state.showSelectTaskStateDialog);
    };

    handleNewTaskWizardTaskPriorityDialogNext = (id: string) => {
        const state = this.state;
        this.setTaskPriority(id, state.newTaskWizardWindowIndex + 1 < state.newTaskWizardWindows.length ? state.newTaskWizardWindowIndex + 1 : -1, state.showSelectTaskPriorityDialog);
    };

    handleNewTaskWizardDialogPrevious = () => {
        const state = this.state;
        const isPrivate = !state.unitId;
        const decrement = isPrivate && state.newTaskWizardWindowIndex > 1 && state.newTaskWizardWindows[state.newTaskWizardWindowIndex - 1] === NewTaskWizardWindowType.Unit
            ? 2
            : 1;
        this.setState({
            newTaskWizardWindowIndex: this.state.newTaskWizardWindowIndex - decrement
        });
    };

    handleNewTaskWizardDialogCancel = () => {
        this.setState({
            newTaskWizardWindowIndex: -1
        });
    };
    //#endregion New Task Wizard

    //#region TaskType
    handleChangeTaskTypeClick = () => {
        this.setState({
            showSelectTaskTypeDialog: true,
        });
    };

    handleLoadTaskTypes = (page: number): Promise<IEndlessList<IIdCodeDivider>> => {
        const obj = this;
        const state = obj.state;
        const isPrivate = !state.unitId;
        return new Promise<IEndlessList<IIdCode>>((resolve, reject) => {
            const result = new EndlessList<IIdCode>(null, IdCode);
            result.items = TaskEditTypeItem.getTaskTypesForUiSelect(this.props.taskTypes, !isPrivate).map(i => { return { id: i.id, code: i.title, divider: i.divider }; });
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    handleSelectTaskTypeDialogOk = (id: string, code: string) => {
        const state = this.state;
        this.setTaskType(id, state.newTaskWizardWindowIndex, false);
    };

    handleSelectTaskTypeDialogCancel = () => {
        this.setState({
            showSelectTaskTypeDialog: false
        });
    };
    //#endregion TaskType

    //#region TaskState
    handleChangeTaskStateClick = () => {
        this.setState({
            showSelectTaskStateDialog: true,
        });
    };

    handleLoadTaskStates = (page: number): Promise<IEndlessList<ITaskStateItem>> => {
        const obj = this;
        return new Promise<IEndlessList<ITaskStateItem>>((resolve, reject) => {
            const result = new EndlessList<ITaskStateItem>(null, TaskStateItem);
            result.items = obj.props.taskStates;
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    handleSelectTaskStateDialogOk = (id: string, code: string) => {
        const state = this.state;
        this.setTaskState(id, state.newTaskWizardWindowIndex, false);
    };

    handleSelectTaskStateDialogCancel = () => {
        this.setState({
            showSelectTaskStateDialog: false
        });
    };
    //#endregion TaskState

    //#region TaskPriority
    handleChangeTaskPriorityClick = () => {
        this.setState({
            showSelectTaskPriorityDialog: true,
        });
    };

    handleLoadTaskPriorities = (page: number): Promise<IEndlessList<IIdCode>> => {
        const obj = this;
        return new Promise<IEndlessList<IIdCode>>((resolve, reject) => {
            const result = new EndlessList<IIdCode>(null, IdCode);
            result.items = obj.props.taskPriorities;
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    handleSelectTaskPriorityDialogOk = (id: string, code: string) => {
        const state = this.state;
        this.setTaskPriority(id, state.newTaskWizardWindowIndex, false);
    };

    handleSelectTaskPriorityDialogCancel = () => {
        this.setState({
            showSelectTaskPriorityDialog: false
        });
    };
    //#endregion TaskPriority

    //#region Unit
    handleChangeUnitClick = () => {
        this.setState({
            showSelectUnitDialog: true,
        });
    };

    handleLoadUnits = (page: number): Promise<IEndlessList<IUnitItem>> => {
        const obj = this;
        return new Promise<IEndlessList<IUnitItem>>((resolve, reject) => {
            const result = new EndlessList<IUnitItem>(null, UnitItem);
            result.items = obj.props.units;
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    handleSelectUnitDialogOk = (id: string, code: string) => {
        const state = this.state;
        this.setUnit(id, state.newTaskWizardWindowIndex, false);
    };

    handleSelectUnitDialogCancel = () => {
        this.setState({
            showSelectUnitDialog: false
        });
    };
    //#endregion Unit

    //#region General
    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "name") {
            this.setState({ name: value });
        }
    };

    handlePrivateChange = (isPrivate: boolean) => {
        const oldIsPrivate = !this.state.unitId;
        if (isPrivate) {
            this.setState({ unitId: null, unitCode: "" });
            if (oldIsPrivate) return;
        } else {
            if (!oldIsPrivate) return;
            const unit = this.props.units[0];
            this.setState({ unitId: unit.id, unitCode: unit.name });
        }
        const oldTaskTypeId = this.state.taskTypeId;
        const relevantTaskTypes = this.props.taskTypes.filter(i => i.isVisible(isPrivate));
        if (relevantTaskTypes.findIndex(i => i.id === oldTaskTypeId) > -1) return;
        this.setState({
            showSelectTaskTypeDialog: true,
        });
    };
    //#endregion General

    //#region Handlers
    handleAddTaskHandlers = (users: IUserListItem[]) => {
        const state = this.state;
        if (!users || users.length < 1) return;
        const taskHandlers = state.taskHandlers.slice(0);
        const savedTaskHandlerIds = state.savedTaskHandlerIds.slice(0);
        for (const user of users) {
            const taskHandler = TaskHandler.createTaskHandler(user.code, user.name, user.picture);
            taskHandlers.push(taskHandler);
            savedTaskHandlerIds.push(taskHandler.id);
        }
        TaskHandler.sortTaskHandlers(taskHandlers);
        this.setState({ taskHandlers, savedTaskHandlerIds });
    };

    handleRemoveTaskHandler = (id: string) => {
        const state = this.state;
        if (Base.isNullOrEmpty(id)) return;
        const taskHandler = state.taskHandlers.find(i => i.id === id);
        if (Base.isNullOrUndefined(taskHandler)) return;
        const removedTaskHandlerIds = state.removedTaskHandlerIds.slice(0);
        if (!taskHandler.isNew()) {
            removedTaskHandlerIds.push(id);
        }
        this.setState({ taskHandlers: state.taskHandlers.filter(i => i.id !== id), removedTaskHandlerIds, savedTaskHandlerIds: state.savedTaskHandlerIds.filter(i => i !== id) });
    };
    //#endregion Handlers

    //#region HeaderForm
    handleEditHeaderForm = () => {
        const state = this.state;
        this.setState({ headerFormEditMode: true, nameOld: state.name, taskHeaderDataColsOld: state.taskHeaderDataCols.map(i => new TaskDataRowCol(i)) });
    };

    handleApproveHeaderForm = () => {
        const state = this.state;
        if (Base.isNullOrEmpty(state.name)) {
            AppUtils.showErrorMessage(Translations.TitleMustBeDefined);
            return;
        }
        TaskTypeCol.validateInputOfRequiredTaskTypeCols(state.taskType.headerCols, state.taskHeaderDataCols, () => {
            this.setState({ headerFormEditMode: false });
        }, (typeCol: ITaskTypeCol) => {
            AppUtils.showErrorMessage(String.format(Translations.FieldParameterValueMustBeDefined, typeCol.title));
        });
    };

    handleCancelHeaderForm = () => {
        const state = this.state;
        this.setState({ headerFormEditMode: false, name: state.nameOld, taskHeaderDataCols: state.taskHeaderDataColsOld.map(i => new TaskDataRowCol(i)) });
    };

    handleRefreshHeaderForm = (taskDataRowCols: ITaskDataRowCol[]) => {
        this.setState({ taskHeaderDataCols: taskDataRowCols });
    };
    //#endregion HeaderForm

    //#region Non repeated task data row attachments
    handleAttachmentAdd = (rowId: string, fileList: FileList) => {
        if (Base.isNullOrEmpty(rowId)) return;
        const taskDataRows = this.state.taskDataRows.slice(0);
        const taskDataRow = taskDataRows.find(i => i.id === rowId);
        if (Base.isNullOrUndefined(taskDataRow)) return;
        FileAttachment.addFileListToFileAttachments(taskDataRow.attachments, fileList, 0).then(attachments => {
            taskDataRow.attachments = attachments;
            this.setState({ taskDataRows });
        });
    };

    handleAttachmentDownload = async (rowId: string, id: string) => {
        if (Base.isNullOrEmpty(rowId) || Base.isNullOrEmpty(id)) return;
        const taskDataRow = this.state.taskDataRows.find(i => i.id === rowId);
        if (Base.isNullOrUndefined(taskDataRow)) return;
        const attachment = taskDataRow.attachments.find(i => i.id === id);
        if (Base.isNullOrUndefined(attachment)) return;
        if (!Base.isNullOrUndefined(attachment.file)) {
            downloadjs(attachment.file, attachment.name); //, "image/jpeg"
            return;
        }
        if (attachment.isNew()) return;
        const result = await AppUtils.callService(() => attachmentService.getAttachment(id), false);
        if (!result) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, result));
    };

    handleAttachmentRemove = (rowId: string, id: string) => {
        if (Base.isNullOrEmpty(rowId) || Base.isNullOrEmpty(id)) return;
        const taskDataRows = this.state.taskDataRows.slice(0);
        const taskDataRow = taskDataRows.find(i => i.id === rowId);
        if (Base.isNullOrUndefined(taskDataRow)) return;
        taskDataRow.attachments = taskDataRow.attachments.filter(i => i.id !== id);
        const photoAttachmentIds = this.state.photoAttachmentIds.filter(i => i !== id);
        const removedAttachmentIds = this.state.removedAttachmentIds.slice(0);
        removedAttachmentIds.push(id);
        this.setState({ taskDataRows, photoAttachmentIds, removedAttachmentIds });
    };
    //#endregion Non repeated task data row attachments

    //#region Repeated task data rows
    handleUpdateRepeatedTaskDataRowToList = (oldTaskDataRowId: string, repeatedTaskDataRow: ITaskDataRow) => {
        if (!repeatedTaskDataRow) return;
        const state = this.state;
        const taskType = state.taskType;
        const repeatedTaskDataRows = state.repeatedTaskDataRows.slice(0);
        const index = state.repeatedTaskDataRows.findIndex(i => i.id === oldTaskDataRowId);
        if (index > -1) {
            repeatedTaskDataRows.splice(index, 1, repeatedTaskDataRow);
        } else {
            repeatedTaskDataRows.push(repeatedTaskDataRow);
        }
        TaskDataRow.sortTaskDataRows(repeatedTaskDataRows, taskType);
        this.setState({ repeatedTaskDataRows });
    };

    handleUpdateRepeatedTaskDataRows = (repeatedTaskDataRows: ITaskDataRow[]) => {
        this.setState({ repeatedTaskDataRows });
    };
    //#endregion Repeated task data rows

    //#region Non repeated task data rows
    handleRefreshTaskDataRowsForm = (rowId: string, taskDataRowCols: ITaskDataRowCol[]) => {
        const taskDataRows = this.state.taskDataRows.slice(0);
        const taskDataRow = taskDataRows.find(i => i.id === rowId);
        if (Base.isNullOrUndefined(taskDataRow)) return;
        taskDataRow.cols = taskDataRowCols;
        this.setState({ taskDataRows });
    };
    //#endregion Non repeated task data rows
            
    //Locking
    //#region Locking
    isLocked = (): boolean => {
        const state = this.state;
        return !Base.isNullOrUndefined(state.lockedDate) && state.lockedDate > 0;
    };

    isLockedToUser = (userCode: string): boolean => {
        const state = this.state;
        return !Base.isNullOrUndefined(state.lockedDate) && state.lockedDate > 0 && !Base.isNullOrEmpty(state.lockedUserCode) && userCode.equalIgnoreCase(state.lockedUserCode);
    };

    isLockedToOtherUser = (userCode: string): boolean => {
        const state = this.state;
        return !Base.isNullOrUndefined(state.lockedDate) && state.lockedDate > 0 && !Base.isNullOrEmpty(state.lockedUserCode) && !userCode.equalIgnoreCase(state.lockedUserCode);
    };

    unlockTask = async (id: string, lockToCurrentUser: boolean, afterUnlock: (result: IUnlockResult) => void = null) => {
        const result = await AppUtils.callService(() => taskService.unlock(id, lockToCurrentUser));
        if (!result) return;
        store.customStore.dispatch(storeActions.taskListSetLocked(id, false));
        if (afterUnlock) {
            afterUnlock(result);
        }
    };

    closeView = (unlock: boolean): void => {
        const props = this.props;
        if (unlock !== null || unlock !== undefined) {
            if (unlock) {
                this.unlockTask(props.item.id, false)
                    .finally(() => {
                        customHistory.push("/task");
                    });
            } else {
                customHistory.push("/task");
            }
        }
    };

    handleUnlockClick = async () => {
        const props = this.props;
        const state = this.state;
        const result = await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToUnlockTask, props.item.name));
        if (result !== ConfirmationDialogResult.Yes) return;
        this.unlockTask(props.item.id, true, (result: IUnlockResult) => {
            this.setState({
                lockedUserCode: result.lockedUserCode ? result.lockedUserCode : state.lockedUserCode,
                lockedUserName: result.lockedUserCode ? props.userName : state.lockedUserCode,
                lockedUserPicture: result.lockedUserCode ? props.userPicture : state.lockedUserPicture,
                lockedDate: result.lockedDate ? result.lockedDate : state.lockedDate,
            });
        });
    };
    //#endregion Locking

    checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            const state = this.state;
            if (Base.isNullOrEmpty(state.name)) {
                AppUtils.showErrorMessage(Translations.TitleMustBeDefined);
                return resolve(false);
            }
            if (state.taskType.headerCols && state.taskType.headerCols.length) {
                TaskTypeCol.validateInputOfRequiredTaskTypeCols(state.taskType.headerCols, state.taskHeaderDataCols, null,
                    (typeCol: ITaskTypeCol) => {
                        AppUtils.showErrorMessage(String.format(Translations.FieldParameterValueMustBeDefined, typeCol.title));
                        return resolve(false);
                    });
            }
            if (!TaskEditView.isRepeatedTask(state.taskType)) {
                for (let i = 0; i < state.taskDataRows.length; i++) {
                    TaskTypeCol.validateInputOfRequiredTaskTypeCols(state.taskType.formCols, state.taskDataRows[i].cols, null,
                        (typeCol: ITaskTypeCol) => {
                            AppUtils.showErrorMessage(String.format(Translations.FieldParameterValueMustBeDefined, typeCol.title));
                            return resolve(false);
                        });
                }
            }
            return resolve(true);
        });
    };

    saveTask = async () => {
        const state = this.state;
        const props = this.props;
        const isLockedToOtherUser = this.isLockedToOtherUser(props.userCode);
        if (isLockedToOtherUser) {
            AppUtils.showErrorMessage(String.format(Translations.LockedTaskParameterCannotBeSaved, props.item.name));
            return;
        }
        if (!await AppUtils.validate(this.checkErrors)) return;
        const unlockOnClose = this.isLockedToUser(props.userCode) && !props.item.isNew();
        const saveData = await TaskEditView.getSaveDataFromState(props, state);
        saveData.append("changed", TaskEditView.orgStateHash !== saveData.getHash(TaskEditView.hashIgnoreSaveDataFields));
        const result = await AppUtils.callService(() => taskService.saveTask(saveData.obj));
        if (!result) return;
        this.closeView(unlockOnClose);
    };

    handleSaveClick = async () => {
        const result = await AppUtils.showConfirmationDialog(Translations.SaveTaskConfirmation, false, storeTypes.ConfirmationDialogType.Information, Translations.SaveTask);
        if (result === ConfirmationDialogResult.Yes) {
            this.saveTask();
        }
    };

    handleBackClick = async () => {
        const props = this.props;
        const unlockOnClose = !this.isLockedToOtherUser(props.userCode) && this.isLockedToUser(props.userCode) && !props.item.isNew();
        const cancelResult = await AppUtils.cancel((await TaskEditView.getSaveDataFromState(this.props, this.state)).getHash(TaskEditView.hashIgnoreSaveDataFields), TaskEditView.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveTask();
        } else {
            this.closeView(unlockOnClose);
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        const item = props.item;
        if (item == null) {
            return (
                <div className="pageBackground" style={ { zIndex: 2 } }>
                    <EditPageHeader
                        title={Translations.Task}
                        onBackClick={this.handleBackClick}
                    />
                </div>
            );
        }
        const taskType = state.taskType;
        const taskState = state.taskState;
        const isPrivate = !state.unitId;
        const isRepeatedTask = TaskEditView.isRepeatedTask(taskType);
        const firstTaskDataRow = state.taskDataRows.length > 0 ? state.taskDataRows[0] : null;
        const isLockedToOtherUser = this.isLockedToOtherUser(props.userCode);
        const formIsLocked = !state.isNew && state.taskType.taskLockingType === TaskLockingType.LockSavedForm;
        //Camera
        const showCamera = state.cameraIds.length > 0 && state.showCamera;
        const showingCamera = showCamera && state.showingCamera;
        return (
            <div className="pageBackground" style={ { zIndex: 2 } }>
                {!showingCamera &&
                    <React.Fragment>
                        <EditPageHeader
                            title={Translations.Task + " - " + (state.isNew ? Translations.ANew : item.code)}
                            onBackClick={this.handleBackClick}
                        />
                        <Footer
                            isReadOnly={isLockedToOtherUser}
                            onClick={this.handleSaveClick}
                        />
                    </React.Fragment>
                }
                <div className="pageContentContainer mainEdit taskEdit">
                    <div className="dataContainer" ref={(elem) => { this.dataContainerDiv = elem; }}>
                        {/* Task */ }
                        <div className="sectionTitle">{Translations.Task + (!state.isNew || !props.canHandleTask || props.taskTypes.length < 2 ? " - " + taskType.code.substr(0, 25) : "")}</div>
                        <LockedToOtherUser
                            isLockedToOtherUser={isLockedToOtherUser}
                            userIsIsSystemAdmin={props.userIsIsSystemAdmin}
                            lockedUserPicture={state.lockedUserPicture}
                            lockedUserName={state.lockedUserName}
                            onUnlockClick={this.handleUnlockClick}
                        />
                        {!(!state.isNew || !props.canHandleTask || props.taskTypes.length < 2) && !isLockedToOtherUser &&
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <div>
                                            <label className="control-label">{Translations.Form}</label>
                                            <ToolButton
                                                tooltip={Translations.Change}
                                                classes={"edit round mono smaller right"}
                                                onClick={this.handleChangeTaskTypeClick}
                                            />
                                        </div>
                                        <div>{taskType.code}</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {!props.canChangeTaskState || props.taskStates.length < 2 || isLockedToOtherUser
                            ? (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.State}</label>
                                            <div>
                                                {!Base.isNullOrEmpty(taskState.color) &&
                                                    <span className="taskStateColor" style={{ background: taskState.color }}></span>
                                                }
                                                <span>{state.taskState.code}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            : (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <div>
                                                <label className="control-label">{Translations.State}</label>
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes={"edit round mono smaller right"}
                                                    onClick={this.handleChangeTaskStateClick}
                                                />
                                            </div>
                                            <div>
                                                {!Base.isNullOrEmpty(taskState.color) &&
                                                    <span className="taskStateColor" style={{ background: taskState.color }}></span>
                                                }
                                                <span>{state.taskState.code}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {!props.canHandleTask || props.taskPriorities.length < 2 || isLockedToOtherUser
                            ? (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.Priority}</label>
                                            <div>{state.taskPriorityCode}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                            : (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <div>
                                                <label className="control-label">{Translations.Priority}</label>
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes={"edit round mono smaller right"}
                                                    onClick={this.handleChangeTaskPriorityClick}
                                                />
                                            </div>
                                            <div>{state.taskPriorityCode}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {state.isNew && props.units.length > 0 && !isLockedToOtherUser &&
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="control-label">{Translations.Category}</label>
                                        <div>
                                            <div className="btn-group btn-group-toggle privacyOptions">
                                                <RadioButton
                                                    classes={"btn-secondary po public " + (!isPrivate ? "active" : "")}
                                                    title={Translations.Public}
                                                    checked={!isPrivate}
                                                    onRadioClickBoolean={(checked: boolean) => { this.handlePrivateChange(!checked); }}
                                                />
                                                <RadioButton
                                                    classes={"btn-secondary po private " + (isPrivate ? "active" : "")}
                                                    title={Translations.Private}
                                                    checked={isPrivate}
                                                    onRadioClickBoolean={(checked: boolean) => { this.handlePrivateChange(checked); }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {!isPrivate
                            ? (
                                !props.canHandleTask || props.units.length < 2 || isLockedToOtherUser
                                    ? (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="control-label">{Translations.Unit}</label>
                                                    <div>{state.unitCode}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <div>
                                                        <label className="control-label">{Translations.Unit}</label>
                                                        <ToolButton
                                                            tooltip={Translations.Change}
                                                            classes={"edit round mono smaller right"}
                                                            onClick={this.handleChangeUnitClick}
                                                        />
                                                    </div>
                                                    <div>{state.unitCode}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                            )
                            : (
                                !state.isNew || props.units.length < 1
                                    ? (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="control-label">{Translations.Visibility}</label>
                                                    <div>{Translations.Private}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : (
                                        null
                                    )
                            )
                        }
                        {/* Title & Header */}
                        <div className="taskHeader">
                            <div className="row">
                                <div className="col-12">
                                    <div className={"form-group" + (props.canHandleTask && state.headerFormEditMode ? " required" : "")}>
                                        <div>
                                            <label className="control-label">{Translations.Title}</label>
                                            {props.canHandleTask && !state.headerFormEditMode && !isLockedToOtherUser &&
                                                <ToolButton
                                                    tooltip={Translations.Edit}
                                                    classes={"edit round mono smaller right"}
                                                    onClick={this.handleEditHeaderForm}
                                                />
                                            }
                                            {props.canHandleTask && state.headerFormEditMode &&
                                                <ToolButton
                                                    tooltip={Translations.Close}
                                                    classes={"closeb black round mono right"}
                                                    onClick={this.handleCancelHeaderForm}
                                                />
                                            }
                                            {props.canHandleTask && state.headerFormEditMode && !isLockedToOtherUser &&
                                                <ToolButton
                                                    tooltip={Translations.Save}
                                                    classes={"check black mui round mono right"}
                                                    onClick={this.handleApproveHeaderForm}
                                                />
                                            }
                                        </div>
                                        {!(props.canHandleTask && state.headerFormEditMode) &&
                                            <div>{state.name}</div>
                                        }
                                        {props.canHandleTask && state.headerFormEditMode &&
                                            <input className="form-control" type="text" name="name" title={Translations.Title} maxLength={100} readOnly={false} disabled={false} value={state.name} required={true} onChange={this.handleChange} />
                                        }
                                    </div>
                                </div>
                            </div>
                            {!Base.isNullOrUndefined(taskType.headerCols) && taskType.headerCols.length > 0 &&
                                <div className="row">
                                    <TaskDynamicForm
                                        isReadOnly={!props.canHandleTask || !state.headerFormEditMode || isLockedToOtherUser}
                                        isEdit={!state.isNew}
                                        taskTypePages={[]}
                                        taskTypeCols={taskType.headerCols}
                                        taskDataRowCols={state.taskHeaderDataCols}
                                        attachmentsElement={null}
                                        onRefreshCols={this.handleRefreshHeaderForm}
                                    />
                                </div>
                            }
                        </div>
                        {/* Form */}
                        {!!taskType.formCols && taskType.formCols.length > 0 && !isRepeatedTask && !!firstTaskDataRow &&
                            <div className="taskForm">
                                <div className="row">
                                    <TaskDynamicForm
                                        isReadOnly={!props.canHandleTask || isLockedToOtherUser || formIsLocked}
                                        isEdit={!state.isNew}
                                        taskTypePages={taskType.pages}
                                        taskTypeCols={taskType.formCols}
                                        taskDataRowCols={firstTaskDataRow.cols}
                                        attachmentsElement={
                                            <AttachmentList
                                                isReadOnly={!props.canHandleTask || isLockedToOtherUser || formIsLocked}
                                                canShowCamera={this.hasCameras()}
                                                lateThreshold={null}
                                                attachments={firstTaskDataRow.attachments}
                                                onDownloadAttachment={ (id: string) => this.handleAttachmentDownload(firstTaskDataRow.id, id) }
                                                onRemoveAttachment={ (id: string) => this.handleAttachmentRemove(firstTaskDataRow.id, id) }
                                                onAddAttachments={(fileList: FileList) => this.handleAttachmentAdd(firstTaskDataRow.id, fileList) }
                                                onAddPhoto={() => this.handleAttachmentAddPhoto(firstTaskDataRow.id, false)}
                                            />
                                        }
                                        onRefreshCols={(taskDataRowCols: ITaskDataRowCol[]) => {
                                            this.handleRefreshTaskDataRowsForm(firstTaskDataRow.id, taskDataRowCols);
                                        }}
                                    />
                                </div>
                            </div>
                        }
                        {/* Rows */}
                        {!Base.isNullOrUndefined(taskType.formCols) && taskType.formCols.length > 0 && isRepeatedTask &&
                            <div className="taskFormRows">
                                <div className="row">
                                    <div className="col-12">
                                        <TaskDataRowList
                                            isNewTask={state.isNew}
                                            isReadOnly={!props.canHandleTask}
                                            userIsIsSystemAdmin={props.userIsIsSystemAdmin}
                                            userCode={props.userCode}
                                            taskId={item.id}
                                            companyId={item.companyId}
                                            cameraIds={state.cameraIds}
                                            taskType={taskType}
                                            taskDataRows={state.repeatedTaskDataRows}
                                            photoAttachmentIds={state.photoAttachmentIds}
                                            newCameraFileAttachment={state.rowDataNewCameraFileAttachment}
                                            onAddPhoto={() => this.handleAttachmentAddPhoto("", true)}
                                            onUpdate={this.handleUpdateRepeatedTaskDataRowToList}
                                            onUpdateTaskDataRows={this.handleUpdateRepeatedTaskDataRows}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {/* TaskHandlers */}
                        {!isPrivate &&
                            <div className="sectionTitle">{Translations.TaskHandlers + " (" + state.taskHandlers.length + ")"}<div className={"btn " + (state.taskHandlersVisible ? "collapseUp" : "expandDown")} onClick={() => { this.setState({ taskHandlersVisible: !state.taskHandlersVisible }); }}><span className="icon"></span></div></div>
                        }
                        {!isPrivate && state.taskHandlersVisible &&
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <TaskHandlerList
                                            isReadOnly={!props.canHandleTask || isLockedToOtherUser}
                                            taskId={state.id}
                                            unitId={state.unitId}
                                            taskHandlers={state.taskHandlers}
                                            onRemove={this.handleRemoveTaskHandler}
                                            onAdd={this.handleAddTaskHandlers}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {/* CalendarTasks */}
                        <CalendarTaskListOfRecord
                            user={props.user}
                            isReadOnly={!props.canHandleTask}
                            databaseRecordType={DatabaseRecordType.Task}
                            recordId={state.id}
                            newRecordNotification={Translations.TaskMustBeSavedBeforeCalendarTasksCanBeAdded}
                            accordionIsVisible={state.calendarTasksVisible}
                            onChangeAccordionIsVisible={(calendarTasksVisible: boolean) => { this.setState({ calendarTasksVisible }); }}
                        />
                    </div>
                </div>
                {showCamera &&
                    <CameraPhoto
                        cameraIds={state.cameraIds}
                        cameraStreamAvailable={state.showingCamera}
                        onCameraStreamAvailable={this.handleCameraStreamAvailable}
                        onOkClick={this.handleCameraPhotoOk}
                        onCancelClick={this.handleCameraPhotoCancel}
                    />
                }
                {state.newTaskWizardWindowIndex > -0.5 && state.newTaskWizardWindows[state.newTaskWizardWindowIndex] === NewTaskWizardWindowType.Category &&
                    <SelectIdCodeDialog
                        nextPreviousMode={true}
                        title={Translations.SelectCategory}
                        selectedId={isPrivate ? CategoryType.Private : CategoryType.Public}
                        loadIdCodes={this.handleLoadCategories}
                        onOk={this.handleNewTaskWizardCategoryDialogNext}
                        onCancel={this.handleNewTaskWizardDialogCancel}
                        onPrevious={state.newTaskWizardWindowIndex > 0 ? this.handleNewTaskWizardDialogPrevious : null}
                    />
                }
                {state.newTaskWizardWindowIndex > -0.5 && state.newTaskWizardWindows[state.newTaskWizardWindowIndex] === NewTaskWizardWindowType.Unit &&
                    <SelectUnitDialog
                        nextPreviousMode={true}
                        title={Translations.SelectUnit}
                        selectedId={state.unitId}
                        companyLogo={this.companyLogo}
                        loadUnits={this.handleLoadUnits}
                        onOk={this.handleNewTaskWizardUnitDialogNext}
                        onCancel={this.handleNewTaskWizardDialogCancel}
                        onPrevious={state.newTaskWizardWindowIndex > 0 ? this.handleNewTaskWizardDialogPrevious : null}
                    />
                }
                {state.newTaskWizardWindowIndex > -0.5 && state.newTaskWizardWindows[state.newTaskWizardWindowIndex] === NewTaskWizardWindowType.TaskType &&
                    <SelectIdCodeDialog
                        nextPreviousMode={true}
                        title={Translations.SelectForm}
                        selectedId={state.taskTypeId}
                        loadIdCodes={this.handleLoadTaskTypes}
                        onOk={this.handleNewTaskWizardTaskTypeDialogNext}
                        onCancel={this.handleNewTaskWizardDialogCancel}
                        onPrevious={state.newTaskWizardWindowIndex > 0 ? this.handleNewTaskWizardDialogPrevious : null}
                    />
                }
                {state.newTaskWizardWindowIndex > -0.5 && state.newTaskWizardWindows[state.newTaskWizardWindowIndex] === NewTaskWizardWindowType.TaskState &&
                    <SelectTaskStateDialog
                        nextPreviousMode={true}
                        title={Translations.SelectTaskState}
                        selectedId={state.taskStateId}
                        loadTaskStates={this.handleLoadTaskStates}
                        onOk={this.handleNewTaskWizardTaskStateDialogNext}
                        onCancel={this.handleNewTaskWizardDialogCancel}
                        onPrevious={state.newTaskWizardWindowIndex > 0 ? this.handleNewTaskWizardDialogPrevious : null}
                    />
                }
                {state.newTaskWizardWindowIndex > -0.5 && state.newTaskWizardWindows[state.newTaskWizardWindowIndex] === NewTaskWizardWindowType.TaskPriority &&
                    <SelectIdCodeDialog
                        nextPreviousMode={true}
                        title={Translations.SelectTaskPriority}
                        selectedId={state.taskPriorityId}
                        loadIdCodes={this.handleLoadTaskPriorities}
                        onOk={this.handleNewTaskWizardTaskPriorityDialogNext}
                        onCancel={this.handleNewTaskWizardDialogCancel}
                        onPrevious={state.newTaskWizardWindowIndex > 0 ? this.handleNewTaskWizardDialogPrevious : null}
                    />
                }
                {state.showSelectUnitDialog &&
                    <SelectUnitDialog
                        title={Translations.SelectUnit}
                        selectedId={state.unitId}
                        companyLogo={this.companyLogo}
                        loadUnits={this.handleLoadUnits}
                        onOk={this.handleSelectUnitDialogOk}
                        onCancel={this.handleSelectUnitDialogCancel}
                    />
                }
                {state.showSelectTaskTypeDialog &&
                    <SelectIdCodeDialog
                        title={Translations.SelectForm}
                        selectedId={state.taskTypeId}
                        loadIdCodes={this.handleLoadTaskTypes}
                        onOk={this.handleSelectTaskTypeDialogOk}
                        onCancel={this.handleSelectTaskTypeDialogCancel}
                    />
                }
                {state.showSelectTaskStateDialog &&
                    <SelectTaskStateDialog
                        title={Translations.SelectTaskState}
                        selectedId={state.taskStateId}
                        loadTaskStates={this.handleLoadTaskStates}
                        onOk={this.handleSelectTaskStateDialogOk}
                        onCancel={this.handleSelectTaskStateDialogCancel}
                    />
                }
                {state.showSelectTaskPriorityDialog &&
                    <SelectIdCodeDialog
                        title={Translations.SelectTaskPriority}
                        selectedId={state.taskPriorityId}
                        loadIdCodes={this.handleLoadTaskPriorities}
                        onOk={this.handleSelectTaskPriorityDialogOk}
                        onCancel={this.handleSelectTaskPriorityDialogCancel}
                    />
                }
            </div>
        );
    }
}